import styles from "../../../styles/shared/create-bot/CreateBotSettings.module.css";
import React from "react";
import { Tooltip } from "antd";
import { IoInformationCircleOutline } from "react-icons/io5";
import { TbReportSearch } from "react-icons/tb";

function SignalSourceSettings({ signalSource, changeConfig }) {
  return (
    <>
      <div className={styles.stepTitle}>
        <h6>
          <TbReportSearch color="#0c4cfc" size={18} /> Which signal source you want to choose?
        </h6>
      </div>

      <div className={styles.signalSourceList}>
        <Tooltip
          title="It covers top 20 crypto coins"
          color="blue"
          className={`${styles.sourceItem} ${
            signalSource === "AI_Assistant" ? styles.active : ""
          }`}
          onClick={() => changeConfig("signal_source", "AI_Assistant")}
        >
          AI Assistant
          <IoInformationCircleOutline color="#0c4cfc" size={18} />
        </Tooltip>
        <Tooltip
          title="It covers all coins but it is recommended to the
            adventurous users"
          color="blue"
          className={`${styles.sourceItem} ${
            signalSource === "VIP_channel" ? styles.active : ""
          }`}
          onClick={() => changeConfig("signal_source", "VIP_channel")}
        >
          VIP signals
          <IoInformationCircleOutline color="#0c4cfc" size={18} />
        </Tooltip>
      </div>
    </>
  );
}

export default SignalSourceSettings;
